import * as Yup from "yup";
import i18next from "i18next";

export function getFormProfileSchema(isForeigner) {
  const PHONE_NUMBER_LENGTH = 10;
  const PHONE_NUMBER_ERROR_MESSAGE = i18next.t(
    "formProfile:formProfile.phoneLengthError"
  );

  const thaiFormSchema = Yup.object({
    currentAddress: Yup.string().optional(),
    currentProvince: Yup.string().optional(),
    currentDistrict: Yup.string().optional(),
    currentSubDistrict: Yup.string().optional(),
    currentPostalCode: Yup.string().optional(),
    idCardAddress: Yup.string().optional(),
    idCardProvince: Yup.string().optional(),
    idCardDistrict: Yup.string().optional(),
    idCardSubDistrict: Yup.string().optional(),
    idCardPostalCode: Yup.string().optional(),
    first_name_1: Yup.string().optional(),
    last_name_1: Yup.string().optional(),
    phone_1: Yup.string().optional(),
    relationship_1: Yup.string().optional(),
    first_name_2: Yup.string().optional(),
    last_name_2: Yup.string().optional(),
    phone_2: Yup.string().optional(),
    relationship_2: Yup.string().optional(),
    status: Yup.string().optional(),
    children: Yup.number().optional(),
    education: Yup.string().optional(),
  });

  const foreignerFormSchema = Yup.object({
    currentAddress: Yup.string().optional(),
    currentProvince: Yup.string().optional(),
    currentDistrict: Yup.string().optional(),
    currentSubDistrict: Yup.string().optional(),
    currentPostalCode: Yup.string().optional(),
    first_name_1: Yup.string().optional(),
    last_name_1: Yup.string().optional(),
    phone_1: Yup.string().optional(),
    relationship_1: Yup.string().optional(),
    first_name_2: Yup.string().optional(),
    last_name_2: Yup.string().optional(),
    phone_2: Yup.string().optional(),
    relationship_2: Yup.string().optional(),
    status: Yup.string().optional(),
    children: Yup.number().optional(),
    education: Yup.string().optional(),
  });

  return isForeigner ? foreignerFormSchema : thaiFormSchema;
}

export function getAdditionalContacts(formValues) {
  const first_additional_contact = {
    first_name: formValues.first_name_1,
    last_name: formValues.last_name_1,
    phone: formValues.phone_1,
    relation: formValues.relationship_1,
  };
  const second_additional_contact = {
    first_name: formValues.first_name_2,
    last_name: formValues.last_name_2,
    phone: formValues.phone_2,
    relation: formValues.relationship_2,
  };

  return [first_additional_contact, second_additional_contact];
}
